import { useEffect, useState } from "react";
import axios from "axios";
import { API_COUNTRIES } from "../Util/URLConstants";

const useCountryList = () => {
  const [state, setState] = useState({
    country: [],
    countryLoading: true,
    error: '',
  });

  useEffect(() => {
    const fetchCountryList = async () => {
      try {
        const response = await axios.get(API_COUNTRIES);
        setState({
          country: response.data?.data || [],
          countryLoading: false,
          error: '',
        });
      } catch (err) {
        console.error("Error fetching country list:", err);
        setState({
          country: [],
          countryLoading: false,
          error: err.message || "Something went wrong",
        });
      }
    };

    fetchCountryList();
  }, []);

  return state;
};

export default useCountryList;
